/**
 * Copyright © 2026 Adnuntius AS.
 * UI-Router state declarations.
 */
import {Ng2StateDeclaration} from '@uirouter/angular';
import {collectStatesFromProvider, AdnRouterHelperApi} from '../routing/state-utils';
import {SIGN_IN_ROUTER_STATE, VIEWS} from './sign-in-views';
import {SignInPageComponent} from './sign-in-page.component';


export function signInStates(adnRouterHelper: AdnRouterHelperApi): Ng2StateDeclaration[] {
  return collectStatesFromProvider(function register($stateProvider, adnRouterHelperProvider) {
$stateProvider.state(SIGN_IN_ROUTER_STATE, {
          url: '/' + SIGN_IN_ROUTER_STATE,
          data: {public: true, view: VIEWS.SIGN_IN},
          params: {
            explicitlySignedOut: null,
            dest: null
          },
          component: SignInPageComponent
        }).state('sign-in.masquerade', {
          url: '/masquerade',
          data: {public: true, view: VIEWS.MASQUERADE}
        }).state('sign-in.password-reset', {
          url: '/password-reset',
          data: {public: true, view: VIEWS.RESET_PASSWORD}
        });
  }, adnRouterHelper);
}
